/**
 * BaseComponent
 * Abstract base class for all UI components
 */
export class BaseComponent {
    constructor() {
        if (this.constructor === BaseComponent) {
            throw new Error('BaseComponent is abstract');
        }
        this.element = null;
        this.eventListeners = [];
    }

    /**
     * Render component (must be implemented by subclasses)
     * @returns {HTMLElement}
     */
    render() {
        throw new Error('render() must be implemented');
    }

    /**
     * Mount component to DOM
     * @param {HTMLElement} container
     */
    mount(container) {
        if (!this.element) {
            this.element = this.render();
        }
        container.appendChild(this.element);
    }

    /**
     * Unmount and cleanup
     */
    destroy() {
        // Remove event listeners
        this.eventListeners.forEach(({ element, event, handler }) => {
            element.removeEventListener(event, handler);
        });
        this.eventListeners = [];

        // Remove from DOM
        if (this.element && this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
        }
        this.element = null;
    }

    /**
     * Register event listener for cleanup
     */
    addEventListener(element, event, handler) {
        element.addEventListener(event, handler);
        this.eventListeners.push({ element, event, handler });
    }
}
